var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgShipworksBishop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3600 1800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-3 {\n        fill: #1e2323;\n      }\n\n      .cls-4 {\n        stroke: #10ccff;\n      }\n\n      .cls-4, .cls-5, .cls-6 {\n        stroke-miterlimit: 10;\n        stroke-width: 20px;\n      }\n\n      .cls-4, .cls-6 {\n        fill: none;\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-5 {\n        fill: #4e5354;\n        stroke: #2b2f30;\n      }\n\n      .cls-8 {\n        isolation: isolate;\n      }\n\n      .cls-6 {\n        stroke: #50f1f9;\n      }\n\n      .cls-9, .cls-10, .cls-11, .cls-12 {\n        fill: #fff;\n      }\n\n      .cls-10 {\n        opacity: .7;\n      }\n\n      .cls-10, .cls-11, .cls-12, .cls-13 {\n        mix-blend-mode: screen;\n      }\n\n      .cls-11 {\n        opacity: .8;\n      }\n\n      .cls-12 {\n        opacity: .9;\n      }\n\n      .cls-14 {\n        fill: #75cdd1;\n      }\n\n      .cls-15 {\n        fill: #333c3d;\n      }\n\n      .cls-13 {\n        fill: #27d0e2;\n        opacity: .3;\n      }\n\n      .cls-16 {\n        fill: #4a4e4f;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 44.91,
    y1: 1221.74,
    x2: 3585.9,
    y2: 572.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#020109"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#140e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b1464"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 2062.04,
    y1: 1760,
    x2: 2062.04,
    y2: 404.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#821137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#380c35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 2572.79,
    y1: 511.58,
    x2: 2572.79,
    y2: 1720.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a53214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#531c0e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Space"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    width: 3600,
    height: 1800
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 707,
    y: 404.94,
    width: 2710.07,
    height: 1355.06
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 2572.79,
    cy: 1115.84,
    r: 604.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1646.7,
    y: 1031.25,
    width: 4.26,
    height: 4.26,
    transform: "translate(-247.78 1468.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 2058.66,
    y: 460.47,
    width: 6.02,
    height: 6.02,
    transform: "translate(276.12 1593.58) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1844.56,
    y: 652.09,
    width: 6.02,
    height: 6.02,
    transform: "translate(77.92 1498.31) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1702.58,
    y: 924.01,
    width: 4.26,
    height: 4.26,
    transform: "translate(-155.58 1476.67) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 3288.7,
    y: 856.81,
    width: 4.26,
    height: 4.26,
    transform: "translate(356.5 2578.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1456.98,
    y: 677.87,
    width: 4.26,
    height: 4.26,
    transform: "translate(-53.47 1230.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 2171.1,
    y: 819.2,
    width: 6.02,
    height: 6.02,
    transform: "translate(55.39 1778.15) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "2325.7 423 2325.7 613.29 2262 635.33 2262 923.07 2325.7 945.12 2325.7 1135.41 2683 1135.41 2683 423 2325.7 423"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1330.27 1124.46 1330.27 934.17 1273.96 912.13 1273.96 624.38 1330.27 602.34 1330.27 412.05 972.96 412.05 972.96 1124.46 1330.27 1124.46"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Hangar"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "2457.88 1062.57 1805.6 1107.26 1153.31 1062.57 1153.31 473.95 1802.48 429.26 2457.88 473.95 2457.88 1062.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M0,0v1800h3600V0H0ZM2452.28,1056.31l-652.28,44.69-652.28-44.69V467.69l649.17-44.69,655.4,44.69v588.62Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1148 468 -12 5 3608 2 2452 468 1807.25 416.75 1148 468"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1799.5 415 1749.5 -99 1850.5 -99 1799.5 415"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "44 1808 -7.22 1808.11 0 1746 1138 1068 44 1808"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "1142 1062.25 -12 1758.25 -12 5.25 1142 465.25 1142 1062.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "2459 1064.25 3598 1747 3603 5.25 2449 465.25 2459 1064.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "2458 1062 3568 1808 44 1808 1141.25 1067.25 1787.54 1111.25 2458 1062"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "2451.87 1056.06 1799.58 1100.75 1147.3 1056.06 1147.3 467.44 1796.47 422.75 2451.87 467.44 2451.87 1056.06"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1800,
    y1: 1111,
    x2: 1800,
    y2: 1808
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "3554.01 1809 3605.22 1809.11 3598.01 1747 2460.01 1069 3554.01 1809"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "3737.82 1169.19 3786.14 1152.21 3758.62 1096.07 2459.67 836.37 3737.82 1169.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "-136.04 1169.19 -184.36 1152.21 -156.84 1096.07 1142.11 836.37 -136.04 1169.19"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgShipworksBishop);
export default __webpack_public_path__ + "static/media/bg-shipworks-bishop.0c713a3baca463c8d3edbc530ea1d22f.svg";
export { ForwardRef as ReactComponent };